import "./navigation-barre.scss";

const navigationBarreInit = (navbar) => {
  let lastScrollY = window.scrollY;
  let scrollTimeout = null;

  const hide = () => {
    navbar.classList.add("navigationBarre--hidden");
  };

  const show = () => {
    navbar.classList.remove("navigationBarre--hidden");
  };

  window.addEventListener("scroll", () => {
    const currentScrollY = window.scrollY;
    const scrollingDown = currentScrollY > lastScrollY;

    navbar.classList.toggle("navigationBarre--scrolled", currentScrollY > 50);

    clearTimeout(scrollTimeout);

    if (currentScrollY < 400 || !scrollingDown) {
      show();
    } else {
      hide();
      scrollTimeout = setTimeout(show, 300);
    }

    lastScrollY = currentScrollY;
  });
};

const onScrollActiveNavLink = (navbar) => {
  const allNavLinks = navbar.querySelectorAll('a[href*="#"]');

  if (!allNavLinks) return;

  const allNavLinksFiltered = [...allNavLinks].filter((link) => {
    const hash = new URL(link.href, location.href).hash;

    return hash && document.querySelector(hash);
  });

  if (!allNavLinksFiltered.length) return;

  const setLinksInactive = () => {
    navbar
      .querySelectorAll("li.is-active")
      .forEach((li) => li.classList.remove("is-active"));
  };

  const setLinkActive = (hash) => {
    setLinksInactive();
    allNavLinksFiltered.forEach((link) => {
      if (new URL(link.href, location.href).hash === hash) {
        link.closest("li")?.classList.add("is-active");
      }
    });
  };

  const intersecting = new Set();

  // Observer every DOM element corresponding to menu anchor-link.
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        // Highlight the menu link if entered anchor section
        if (entry.isIntersecting) {
          setLinkActive(`#${entry.target.id}`);
          intersecting.add(entry.target.id);
        } else {
          // Remove highlight the menu link if entered anchor section
          intersecting.delete(entry.target.id);
        }
      });

      // Romove highlighted nav link When DOM section doesn't correspond to nav menu anchor link.
      if (intersecting.size === 0) {
        setLinksInactive();
      }
    },
    { rootMargin: "0px 0px -80% 0px" },
  );

  allNavLinksFiltered.forEach((link) => {
    const section = document.querySelector(
      new URL(link.href, location.href).hash,
    );
    if (section) observer.observe(section);
  });
};

const onToggleMobileMenu = (navbar) => {
  const burger = navbar.querySelector(".navigationBarre__burger");
  const overlay = navbar.querySelector(".navigationBarre__overlay");

  if (!burger || !overlay) return;

  const getFocusableElements = () => [
    ...overlay.querySelectorAll(
      'a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])',
    ),
  ];

  const openMenu = () => {
    burger.classList.add("navigationBarre__burger--open");
    overlay.classList.add("navigationBarre__overlay--open");
    navbar.classList.add("navigationBarre--overlay-open");
    burger.setAttribute("aria-expanded", "true");
    burger.setAttribute("aria-label", "Fermer le menu");
    document.body.style.overflow = "hidden";
    getFocusableElements()[0]?.focus();
  };

  const closeMenu = () => {
    burger.classList.remove("navigationBarre__burger--open");
    overlay.classList.remove("navigationBarre__overlay--open");
    navbar.classList.remove("navigationBarre--overlay-open");
    burger.setAttribute("aria-expanded", "false");
    burger.setAttribute("aria-label", "Ouvrir le menu");
    document.body.style.overflow = "";
    burger.focus();
  };

  overlay.addEventListener("keydown", (e) => {
    if (e.key === "Escape") {
      closeMenu();
      return;
    }

    if (e.key === "Tab") {
      const focusable = getFocusableElements();
      const first = focusable[0];
      const last = focusable[focusable.length - 1];

      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    }
  });

  burger.addEventListener("click", () => {
    const isOpen = burger.getAttribute("aria-expanded") === "true";
    isOpen ? closeMenu() : openMenu();
  });

  overlay.querySelectorAll("a").forEach((link) => {
    link.addEventListener("click", closeMenu);
  });
};

document.addEventListener("DOMContentLoaded", () => {
  const navbar = document.querySelector(".navigationBarre");
  if (!navbar) return;

  navigationBarreInit(navbar);
  onToggleMobileMenu(navbar);
  onScrollActiveNavLink(navbar);
});
